<template>
  <div class="share-network-list">
    <ShareNetwork v-for="n in networks" :key="n.name" @open="openNetwork"
        :network=n.network
        :url="url"
        title="Check out my infusion!"
        >
        <i><font-awesome-icon :icon="['fab', n.icon]" size="lg" /></i>
        <span>{{n.name}}</span>
    </ShareNetwork>
  </div>
</template>

<script>
export default {
    name: 'Sharing',
    props: {
        url: String
    },
  data: function() {
    return {
        networks: [
            { network: 'facebook', name: 'Facebook', icon: 'facebook-f'},
            { network: 'messenger', name: 'Messenger', icon: 'facebook-messenger'},
            { network: 'twitter', name: 'Twitter', icon: 'twitter'},
            { network: 'reddit', name: 'Reddit', icon: 'reddit-alien'},
            { network: 'telegram', name: 'Telegram', icon: 'telegram-plane'},
            { network: 'whatsapp', name: 'Whatsapp', icon: 'whatsapp'}
        ]
    }
  },
  methods:{
      openNetwork(network,url) {
        this.$ga.event({
            eventCategory: 'sharing',
            eventAction: network,
            eventLabel: url
        })
      }
  }
}
</script>

<style>
a[class^="share-network-"] {
    flex: none;
    color: #FFFFFF;
    border-radius: 3px;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-content: center;
    align-items: center;
    cursor: pointer;
    margin: 0 10px 10px 0;
    text-decoration: none;
    font-size: 1.2rem;
}

a[class^="share-network-"] span {
    padding: 0 8px;
    flex: 1 1;
    font-weight: 500;
}

a[class^="share-network-"] i {
    background-color: rgba(0, 0, 0, 0.2);
    min-width: 2rem;
    padding: 6px;
}

.share-network-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    margin: auto;
}

.share-network-facebook {
  background-color: rgb(24, 119, 242);
}
.share-network-twitter {
    background-color: #1da1f2;
}
.share-network-messenger {
    background-color: rgb(0, 132, 255);
}
.share-network-reddit {
    background-color: rgb(255, 69, 0);
}
.share-network-telegram {
    background-color: rgb(0, 136, 204);
}
.share-network-whatsapp {
    background-color: rgb(37, 211, 102);
}
</style>